<template>
  <div class="dates_form">
    <div 
      v-if="!hide_header"
      class="head">
      <h5 style="display:inline">{{title}}</h5>
      <span>
        <b-form-checkbox
          class="ml-2"
          v-model="mutableNotRequired"
          :value="true"
          :unchecked-value="false"
          inline
          >Not Required</b-form-checkbox>
      </span>
    </div>
    <div class="mx-2" v-for="(element, index) in mutableDates" :key="title + index">
      <label :for="title + index">{{element.name}}</label>
      <b-datepicker 
        :disabled="disabled"
        :id="title + index"
        locale="en"
        type="date"
        today-button
        reset-button
        close-button
        v-model="element.date"></b-datepicker>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    dates: Array,
    disabled: Boolean,
    not_required: Boolean,
    hide_header: Boolean,
    callBackFunction: { type: Function },
    updateNotRequired: { type: Function },
  },
  data() {
    return {
      mutableDates: [],
      mutableNotRequired: null,
      mutableProgress: "",
      isSettingUp: true,
    }
  },
  watch: {
    mutableDates: {
      immediate: true,
      deep: true,
      handler(new_dates, old_dates) {
        if (old_dates == null) return;
        // console.log(old_dates);
        // console.log(new_dates);
        // console.log('ddd');
        this.callBackFunction(new_dates);
      }
    },
    mutableNotRequired: {
      immediate: true,
      deep: true,
      handler(new_data, old_data) {
        if (old_data == null) return;
        // console.log(old_data);
        // console.log(new_data);
        // console.log('kkk');
        this.updateNotRequired(new_data);
      }
    }
  },
  created() {
    // console.log(this.not_required);
    this.mutableDates = this.dates.splice(0);
    this.mutableNotRequired = this.not_required;
  },
}
</script>

<style>

</style>